<template>
  <div id="tixianbutton" class="whiteB">
    <span>剩余可提现(元)：</span>
    <span class="money">{{ (money*1).toFixed(2) }}</span>
    <a class="absoluteItem centerY radius3" :class="{disable:clicked}" @click="ableMoney">去提现</a>
    <!-- <router-link to="/tx" class="absoluteItem centerY radius3">去提现</router-link> -->

    <!--弹窗-->
    <div class="tc" v-show="tc">
      <div class="center absoluteItem centerImg whiteB">
        <p>{{ text }}</p>
        <button class="commonBk" @click="close_tc">确定</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "tixianbutton",
  components: {},
  props: ["money"],
  data() {
    return {
      is: 0,
      text: "请先前往APP进行手机绑定",
      tc: false,
      clicked: false,
    };
  },
  methods: {
    close_tc() {
      this.tc = false;
      document.getElementsByTagName("body")[0].style.overflow = "scroll";
    },
    /**提现可用金额 */
    ableMoney() {
      if (!this.clicked) {
        this.clicked = true;
      } else {
        return;
      }

      let _this = this;
      _this.$jsonp(this.$apis("txAble"), {}, (res) => {
        if (res.data.data.status == 200) {
          //判断是否需要用户输入身份证
          if (res.data.data.msg === "tanchuang") {
            _this.is = res.data.data.is;

            if (_this.$cookie.getC("platform") == "app") {
              let data = { action: _this.is };
              _this.$appAc.verify(data);
            } else {
              //显示弹窗 提示用户去app操作
              if (_this.is == 1) {
                _this.text = "请先前往APP进行手机绑定";
              } else if (_this.is == 2) {
                _this.text = "请先前往APP进行身份信息绑定";
              } else if (_this.is == 3) {
                _this.text = "请先前往APP进行手机和身份信息绑定";
              }
              _this.tc = true;
              document.getElementsByTagName("body")[0].style.overflow =
                "hidden";
            }
          } else {
            //不需要绑定
            //在app内就前往app的提现页面
            if (_this.$appAc.platform == "app") {
              let data = {
                ios: {
                  app_open: "appjump",
                  url:`{"className":"WalletWithdrawVC","property":{"pearlBalance":${parseInt(_this.money*100)}}}`
                },
                android: {
                  app_open: "appjump",
                  url:"withdraw?pearl=" + parseInt(_this.money*100),
                },
              };
              _this.$appAc.actionAsPhp(data);
            } else {
              _this.$router.push({ path: "/tx" });
            }
          }

          //允许再次点击
          _this.clicked = false;
        }
      });
    },
  },
  mounted: function () {},
};
</script>

<style scoped>
#tixianbutton {
  border-top: 1px solid #f4f4f4;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0.7rem;
  font-size: 15px;
}
#tixianbutton * {
  vertical-align: middle;
}
.money {
  font-weight: 600;
}
a {
  display: inline-block;
  right: 1rem;
  color: #fff;
  font-size: 11px;
  padding: 0.4rem 0.7rem;
  background: -webkit-linear-gradient(left, #f6d365, #fda085);
  background: linear-gradient(to right, #f6d365, #fda085);
}
.disable {
  background: #e4e4e4;
}

.center {
  width: 80%;
  text-align: center;
  padding: 0.5rem;
  border-radius: 10px;
}
.center p {
  font-size: 15px;
  margin: 1.2rem 0;
  margin-bottom: 1.5rem;
}
.center button {
  width: 40%;
  padding: 0.5rem 0;
  color: white;
  font-size: 14px;
  border-radius: 3rem;
  margin-bottom: 0.4rem;
}
</style>
